import ssoImg1 from "./../../../../assets/images/tabimg-1.png"; // Adjust the path as necessary
import ssoImg2 from "./../../../../assets/images/tabimg-2.png"; // Adjust the path as necessary


function AssessmentCertificationTab() {
  return (
    <>
      <div className="service-title font-700 mb-3">SEAFARER <span className="text-orange-ef3e33 font-400 text-uppercase">Assessment And Certification</span></div>

<div className="row g-3 g-sm-4 g-md-5">
   
    <div className="col-12">
        {/* <p className="font-18 mb-4">
           SAMSA’s Maritime Occupational Health and Safety Unit aims to improve health and safety standards and awareness in the stevedore and ship repair industries through:
        </p> */}

        <ul className="trust">
            <li>The Office of the Chief Examiner and that of the Registrar of Seafarers are responsible for the whole value chain of seafarers training and certification. </li>
            <li>The issuing of the Certificate is an event in each of the process followed to be issued with the certificate under each circumstance. </li>
            <li>Thus, accordingly, SAMSA does not publish the information relating to issuing of certificates of competency and/or proficiency, other than for small vessels.</li>
            <li>Certificated Seafarers, or persons aspiring to be certificated seafarers, should follow the various procedures that are described briefly herein. </li>
            <li>Seafarers can apply for various certificates under different circumstances. The links below will take you to pages where more information is available regarding the specific procedure you need to follow.</li>
            <li><a href="#">Initial Application, encompassing the​</a>
             <ul className="star-li">
                    <li>Level 3 Assessment (Oral Examinations) for officers</li>
                    <li>Applications for Radio Certificates</li>
                    <li>Initial application for Ratings</li>
                    <li>Initial application for other certificates where no Level 3 Assessment is required</li>
                </ul>
            </li>
            <li><a href="#">Revalidation of Certificates, encompassing​​</a>
             <ul className="star-li">
                    <li><a href="#">  Revalidations for Officers</a></li>
                    <li>Revalidations for Radio Certificates</li>
                    <li>Revalidation for Ratings</li>
                    <li>Revalidation for other certificates where no Level 3 Assessment is required</li>                      
                    </ul>
            </li>
            <li><a href="#"> General applications, encompassing​</a>
             <ul className="star-li">
                    <li>Applications for CEC</li>
                    <li>Applications for Lost/Destroyed Certificates</li>
                    </ul>
            </li>
            <li>For general enquiries, you can send an e-mail to the Chief Examiner at<a class="mailto" href="mailto:exams@samsa.org.za">exams@samsa.org.za</a></li>
            <br></br>
        </ul>

    </div>
    
</div>
    </>
  );
}

export default AssessmentCertificationTab;